<template>
  <cTable ref="form" :methods="methods" :form="form" :config="config"> </cTable>
</template>

<script>
import {
  getLoadType,
  getTransportAgent,
  getShippingMode,
  // getZhongGang,
  operAirOrder,
  getAirLine,
  getCustomer,
  getZhongGangByClient,
} from "@/api/tracker/air";
import { dblpackingAir } from "@/api/packing/packing";
// import { getCountry } from "@/api/system/country";
import cTable from "@/base/common/index";
export default {
  name: "newAirWaybill",
  components: {
    cTable,
  },
  async created() {
    this.form.fields = this.form.fields.concat(this.addField("extract"));
    this.form.fields = this.form.fields.concat(this.addField("relation"));

    this.form.fields.forEach((el, idx) => {
      if (idx === 0 || idx === 1) return;
      this.form.config.rules[el.key] = [
        {
          required: el.isRequired ? false : true,
          type:
            el.component == "DatePicker"
              ? "date"
              : el.isNumber
                ? "number"
                : "string",
          message: el.placeholder.call(this),
          trigger:
            el.component == "Select" || el.component == "DatePicker"
              ? "change"
              : "blur",
        },
      ];
    });
    let load_type = (await getLoadType()).data.payload;
    let air_agent = (await getTransportAgent({ type: 2 })).data.payload;
    let baoguan_agent = (await getTransportAgent({ type: 4 })).data
      .payload;
    let clearance_agent_id = (await getTransportAgent()).data.payload;
    let from_station = (await dblpackingAir()).data.payload;
    let air_line = (await getAirLine()).data.payload;
    let shipping_mode = (await getShippingMode()).data.payload;
    this.setDataFn({
      load_type,
      air_agent,
      baoguan_agent,
      clearance_agent_id,
      file_agent: clearance_agent_id,
      from_station,
      air_line,
      shipping_mode,
      to_station: from_station,
      hk_agent: baoguan_agent,
    });
  },
  methods: {
    // 注入下拉框的值
    setDataFn(nowVal) {
      this.form.fields.forEach((el, idx) => {
        if (el.key.split("-")[1] && nowVal[el.key.split("-")[1]]) {
          this.$set(
            this.form.fields[idx],
            "options",
            nowVal[el.key.split("-")[1]]
          );
        }
      });
    },
    addField(str) {
      return [
        {
          key: str + "-mawb",
          name: () => this.$t("airWaybillNumber"),
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("airWaybillNumber");
          },
        },
        {
          key: str + "-air_line",
          name: () => this.$t("airLine"),
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("airLine");
          },
          options: [],
        },
        {
          key: str + "-from_station",
          name: () => this.$t("from_station"),
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("from_station");
          },
          options: [],
        },
        {
          key: str + "-to_station",
          name: () => this.$t("to_station") + this.$t("airport_t"),
          component: "Select",
          placeholder() {
            return (
              this.$t("select") + this.$t("to_station") + this.$t("airport_t")
            );
          },
          options: [],
          // config: {
          //   label: "code",
          //   value: "code"
          // }
        },
        {
          key: str + "-expected_date",
          name: () => this.$t("amount_actual") + this.$t("takeOffTime"),
          component: "DatePicker",
          disabledDate: true,
          bind: {
            type: "datetime",
          },
          placeholder() {
            return (
              this.$t("select") +
              this.$t("amount_actual") +
              this.$t("takeOffTime")
            );
          },
        },
        {
          key: str + "-dept_date",
          name: () => this.$t("amount_actual") + this.$t("landingTime"),
          component: "DatePicker",
          disabledDate: true,
          bind: {
            type: "datetime",
          },
          placeholder() {
            return (
              this.$t("select") +
              this.$t("amount_actual") +
              this.$t("landingTime")
            );
          },
        },
        {
          key: str + "-flight",
          name: () => this.$t("flight"),
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("flight");
          },
        },
        {
          key: str + "-load_type",
          name: () => this.$t("load_type"),
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("load_type");
          },
          options: [],
        },
        {
          key: str + "-shipping_mode",
          name: () => this.$t("shipping_mode"),
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("shipping_mode");
          },
          options: [],
        },
        {
          key: str + "-weight",
          name: () => this.$t("Weight"),
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("Weight");
          },
          bind: {
            type: "number",
          },
        },
        {
          key: str + "-volume",
          name: () => this.$t("square") + "(CBM)",
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("square") + "(CBM)";
          },
          bind: {
            type: "number",
          },
        },
        {
          key: str + "-items",
          name: () => this.$t("invoicePCS"),
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("invoicePCS");
          },
          bind: {
            type: "number",
          },
        },
        {
          key: str + "-hk_agent",
          name: () => this.$t("HKagency"),
          component: "Select",
          isNumber: true,
          isRequired: true,
          placeholder() {
            return this.$t("select") + this.$t("HKagency");
          },
          options: [],
        },
        {
          key: str + "-clearance_agent_id",
          name: () => this.$t("clearagent"),
          component: "Select",
          isNumber: true,
          isRequired: true,
          placeholder() {
            return this.$t("select") + this.$t("clearagent");
          },
          options: [],
          // methods: {
          //   async "on-change"({ value, field, fields }) {
          //     if (field.key == "extract-clearance_agent_id") {
          //       fields.forEach(async el => {
          //         if (el.key == "packing_number") {
          //           let res = (
          //             await getZhongGang({
          //               agent_id: value,
          //               transport_code: "A"
          //             })
          //           ).data.payload;
          //           el.options = res;
          //           return;
          //         }
          //       });
          //     }
          //   }
          // }
        },
        {
          key: str + "-baoguan_agent",
          name: () => this.$t("warehousCustomsAgent"),
          component: "Select",
          isNumber: true,
          isRequired: true,
          placeholder() {
            return this.$t("select") + this.$t("warehousCustomsAgent");
          },
          options: [],
        },
        {
          key: str + "-air_agent",
          name: () => this.$t("air_agent"),
          component: "Select",
          isNumber: true,
          isRequired: true,
          placeholder() {
            return this.$t("select") + this.$t("air_agent");
          },
          options: [],
        },
        {
          key: str + "-file_agent",
          name: () => this.$t("fileAgent"),
          component: "Select",
          isNumber: true,
          isRequired: true,
          placeholder() {
            return this.$t("select") + this.$t("fileAgent");
          },
          options: [],
        },
        {
          key: str + "-remarks",
          name: () => this.$t("order_desc"),
          component: "Input",
          isRequired: true,
          bind: {
            type: "textarea",
            rows: 4,
          },
          placeholder() {
            return this.$t("enter") + this.$t("order_desc");
          },
        },
      ];
    },
  },
  data() {
    let that = this;
    return {
      selData: {},
      methods: {
        operAirOrder,
        getCustomer,
        getZhongGangByClient,
      },
      config: {
        bind: { style: "min-height:100%;height:auto" },
      },
      form: {
        config: {
          modalBind: {
            width: 600,
          },
          formBind: {
            labelWidth: 140,
          },
          rowBind: {
            gutter: 13,
            style: {
              marginBottom: "20px",
            },
          },
          rules: {
            // client_id: [
            //   {
            //     required: true,
            //     message: "name cannot be empty",
            //     trigger: "change",
            //     type: "number"
            //   }
            // ]
            // packing_number: [
            //   {
            //     required: true,
            //     message: "name cannot be empty",
            //     trigger: "change",
            //     type: "array"
            //   }
            // ]
          },
        },
        grid: [
          // {
          //   name: "中港单号",
          //   children: [{ packing_number: 24 }],
          // },
          {
            name: this.$t("first_bill"),
            key: "extract",
            show: true,
            children: [
              {
                client_id: 6,
                "extract-mawb": 6,
                "extract-air_line": 6,
                "extract-from_station": 6,
              },
              {
                "extract-to_station": 6,
                "extract-expected_date": 6,
                "extract-dept_date": 6,
                "extract-flight": 6,
              },
              {
                "extract-shipping_mode": 6,
                "extract-weight": 6,
                "extract-volume": 6,
                "extract-items": 6,
              },
              {
                "extract-hk_agent": 6,
                "extract-clearance_agent_id": 6,
                "extract-air_agent": 6,
                "extract-baoguan_agent": 6,
              },
              {
                "extract-load_type": 6,
                "extract-file_agent": 6,
                packing_number: 12,
              },
              {
                "extract-remarks": 12,
              },
            ],
          },
          {
            name: this.$t("secondary_bill"),
            show: false,
            key: "relation",
            children: [
              {
                "relation-mawb": 6,
                "relation-air_line": 6,
                "relation-from_station": 6,
                "relation-to_station": 6,
              },
              {
                "relation-expected_date": 6,
                "relation-dept_date": 6,
                "relation-flight": 6,
                "relation-load_type": 6,
              },
              {
                "relation-shipping_mode": 6,
                "relation-weight": 6,
                "relation-volume": 6,
                "relation-items": 6,
              },
              {
                "relation-hk_agent": 6,
                "relation-clearance_agent_id": 6,
                "relation-air_agent": 6,
                "relation-baoguan_agent": 6,
              },
              { "relation-file_agent": 6, "relation-remarks": 18 },
            ],
          },
          {
            button: 10,
          },
        ],
        fields: [
          {
            key: "client_id",
            name: () => this.$t("clientName"),
            component: "Select",
            placeholder() {
              return this.$t("enter") + this.$t("clientName");
            },
            options: [],
            methods: {
              async list({ field, row }) {
                let res = (await getCustomer()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
              async "on-change"({ value, field, fields, row }) {
                if (value) {
                  fields.forEach(async (el) => {
                    if (el.key == "packing_number") {
                      let res = (await getZhongGangByClient({ id: value })).data
                        .payload;
                      el.options = res;
                      this.$forceUpdate();
                      return;
                    }
                  });
                } else {
                  fields.forEach(async (el) => {
                    if (el.key == "packing_number") {
                      row[el.key] = "";
                      el.options = [];
                      this.$forceUpdate();
                      return;
                    }
                  });
                }
              },
            },
          },
          {
            key: "packing_number",
            name: () => this.$t("packing_number"),
            component: "Select",
            options: [],
            bind: {
              multiple: true,
              allowCreate: true,
            },
            config: {
              label: "label",
              value: "label",
            },
            placeholder() {
              return this.$t("enter") + this.$t("packing_number");
            },
            methods: {
              async "on-change"({ value, field, fields, row }) {
                console.log(typeof value);
              },
            },
          },
        ],
        buttons: [
          {
            name: () => this.$t("cancel") + this.$t("newSecond"),
            bind: { type: "error" },
            type: "cancel",
            show: false,
            methods: {
              click({ grid, buttons, btn }) {
                grid[1]["show"] = false;
                buttons.forEach((item) => {
                  if (item.type === "add") {
                    item.show = true;
                  }
                });
                btn.show = false;
              },
            },
          },
          {
            name: () => this.$t("newSecond"),
            bind: { type: "success" },
            type: "add",
            methods: {
              click({ grid, buttons, btn }) {
                grid[1]["show"] = true;
                buttons.forEach((item) => {
                  if (item.type === "cancel") {
                    item.show = true;
                  }
                });
                btn.show = false;
              },
            },
          },
          {
            name: () => this.$t("order_submit"),
            bind: { type: "primary" },
            isSub: true,
            methods: {
              click({ grid, formData, buttons }) {
                let data = {};
                console.log(this);
                grid.forEach((el) => {
                  if (el.key && el.show) {
                    data[el.key] = {};
                    for (const key in formData) {
                      if (key.split("-")[0] == el.key) {
                        if (
                          key.split("-")[1] == "expected_date" ||
                          key.split("-")[1] == "dept_date"
                        ) {
                          data[el.key][key.split("-")[1]] = formData[key]
                            ? this.$page.format.timeFormat(
                              formData[key],
                              "YYYY-MM-DD HH:MM:SS"
                            )
                            : "";
                        } else {
                          data[el.key][key.split("-")[1]] = formData[key];
                        }
                      }
                    }
                  }
                });
                data["packing_number"] = formData["packing_number"];
                data["client_id"] = formData["client_id"];
                data["method"] = "post";
                this.$page
                  .handleRequestMethods("operAirOrder", data, true)
                  .then((res) => {
                    this.$refs["form"].resetFields();
                    grid[1]["show"] = false;
                    buttons.forEach((item) => {
                      if (item.type === "add") item.show = true;
                      if (item.type === "cancel") item.show = false;
                    });
                  });
                // console.log("formData", grid, formData);
              },
            },
          },
        ],
      },
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
